import { render, staticRenderFns } from "./RegisterAuditSidebar.vue?vue&type=template&id=b8f4126e&scoped=true"
import script from "./RegisterAuditSidebar.vue?vue&type=script&lang=js"
export * from "./RegisterAuditSidebar.vue?vue&type=script&lang=js"
import style0 from "./RegisterAuditSidebar.vue?vue&type=style&index=0&id=b8f4126e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f4126e",
  null
  
)

export default component.exports